import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

export const fragments = graphql`
  fragment FocusArea_FocusHero on PrismicFocusAreaDataBodyFocusHero {
    id
    slice_type
    primary {
      focus_hero_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 496)
      }
      focus_hero_text {
        text
      }
      focus_hero_title {
        text
      }
    }
  }

  fragment Page_FocusHero on PrismicPageDataBodyFocusHero {
    id
    slice_type
    primary {
      focus_hero_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 496)
      }
      focus_hero_text {
        text
      }
      focus_hero_title {
        text
      }
    }
  }
`;

function FocusHero({ data }) {
  return (
    <div className="focus-hero">
      <div className="focus-hero__col">
        <h2 className="h3 focus-hero__title">
          {data?.primary?.focus_hero_title?.text}
        </h2>
        <p className=" focus-hero__description">
          {data?.primary?.focus_hero_text?.text}
        </p>
      </div>
      <div className="focus-hero__img">
        {data?.primary?.focus_hero_image?.gatsbyImageData && (
          <GatsbyImage
            image={data?.primary?.focus_hero_image?.gatsbyImageData}
            alt={data?.primary?.focus_hero_image?.alt}
          />
        )}
      </div>
    </div>
  );
}

export default FocusHero;
